<template>

<div class="input" :data-size="size" v-bind:class="{'is-buttons': buttons, 'has-colour': colour, 'is-stacked': stacked}">

	<div class="input-colour" v-if="colour" :style="{backgroundColor: colour}" />

	<div class="input-text" v-if="text">

		<div>{{ text }}</div>

		<div class="input-subtext" v-if="subtext">{{ subtext }}</div>

	</div>

	<div class="input-toggle" v-touch:swipe="onSwipe">

		<div v-for="(label, index) in labels" v-bind:key="index" class="input-toggle-item" v-bind:class="{'is-active': values[index] === value}" v-on:click="onClick(values[index])">{{ labels[index] }}<i v-if="icons[index]" v-bind:class="'fa fa-' + icons[index]" /></div>
		
	</div>

</div>

</template>

<script>

export default {

	props: [
		'filter', 'text', 'subtext', 'size', 'colour', 'defaultValue', 'labels', 'stacked', 'values', 'icons', 'buttons', 'posneg'
	],

	computed: {

		value: function() {

			var value = 0

			if (this.filter) {

				if (this.posneg) {

					if (this.$_.contains(this.$store.getters['filter/' + this.filter], '+' + this.posneg.toString())) {

						value = 3

					} else if (this.$_.contains(this.$store.getters['filter/' + this.filter], '-' + this.posneg.toString())) {

						value = 2

					} else if (this.$_.contains(this.$store.getters['filter/' + this.filter], this.posneg.toString())) {

						value = 1

					}

				} else {

					if (this.filter) value = this.$store.getters['filter/' + this.filter] 

					if (typeof value === 'boolean') {

						value = (value) ? 1 : 0

					}

				}
				
			}

			if (this.defaultValue) value = this.defaultValue
			
			return value

		}

	},

	methods: {

		onClick: function(value) {

			if (this.filter) {

				if (this.posneg) {

					if (value === 3) value = '+' + this.posneg.toString()
					if (value === 2) value = '-' + this.posneg.toString()
					if (value === 1 || value === true) value = this.posneg.toString()

					this.$store.commit('filter/' + this.filter, {
						id: this.posneg,
						value: value
					})

				} else {

					this.$store.commit('filter/' + this.filter, value)

				}

			}

			this.$emit('change', value)

		},

		onSwipe: function(direction) {

			if (!this.buttons) {

				if (direction === 'right') {

					if (this.values[0] === this.value) this.onClick(this.values[1])
					else if (this.values[1] === this.value) this.onClick(this.values[2])

				} else if (direction === 'left') {

					if (this.values[1] === this.value) this.onClick(this.values[0])
					else if (this.values[2] === this.value) this.onClick(this.values[1])

				}

			}

		}

	}

}

</script>

<style scoped>

.input {
	position: relative;
	height: 24px;
	padding: 0px 0px;
	margin-bottom: 8px;
}

.input.has-colour {
	padding-left: 20px;
}

.input.is-stacked {
	height: auto;
}

.input-colour {
	position: absolute;
	left: 0px;
	top: 3px;
	width: 16px;
	height: 16px;
	border-radius: 4px;
	border: 1px solid #fff;
}

.input-text {
	font-size: 12px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 22px;
	color: #fff;
	font-weight: 400;
}

.input-subtext {
	color: #dadada;
	font-size: 11px;
	margin-top: 1px;
}

.input-toggle {
	position: absolute;
	right: 0px;
	top: 0px;
	height: 24px;
	border-radius: 4px;
	background-color: #4a7888;
	overflow: hidden;
	border: 1px solid #024359;
	display: flex;
}

.input[data-size="2"] .input-toggle {
	left: 0px;
	display: grid;
	grid-template-columns: 1fr 1fr;
}

.input[data-size="3"] .input-toggle {
	left: 0px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
}

.input.is-stacked .input-toggle {
	height: auto;
	position: relative;
	top: auto;
	left: auto;
	flex-direction: column;
	width: 100%;
}

.input-toggle-item {
	height: 22px;
	padding: 0px 6px;
	line-height: 22px;
	cursor: pointer;
	font-size: 12px;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.75);
}

.input[data-size="2"] .input-toggle-item,
.input[data-size="3"] .input-toggle-item {
	text-align: center;
}

.input.is-stacked .input-toggle-item {
	width: 100%;
}

.input.is-buttons .input-toggle-item {
	width: 64px;
	text-align: center;
}

.input-toggle-item.is-active {
	background-color: #024359;
	color: #fff;
	border-radius: 4px;
}

.is-desktop .input-toggle-item:hover {
	color: #fff;
}

</style>
